export const CLIENT_CATEGORIES = ["Incorporadora", "Construtora", "Loteadora", "Imobiliária", "Grupo"];

export const CLIENTS = [
  { name: "Adão Incorporadora", category: "Incorporadora" },
  { name: "Level Empreendimentos", category: "Incorporadora" },
  { name: "São Benedito", category: "Loteadora" },
  { name: "Capital Construtora", category: "Construtora" },
  { name: "Verde Construtora", category: "Construtora" },
  { name: "Águas Group", category: "Grupo" },
  { name: "Horizonte Incorp.", category: "Incorporadora" },
  { name: "Reserva Empreend.", category: "Incorporadora" },
  { name: "Edge Group", category: "Grupo" },
  { name: "Brilhante Imóveis", category: "Imobiliária" },
  { name: "Cerrado Loteadora", category: "Loteadora" },
  { name: "Norte Sul Constr.", category: "Construtora" },
];
